import { Component } from "react";
import { Urls, Paths } from "../../constants/UrlConstants";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Layouts } from "../../constants/Constants";

class ThriveInfoPage extends Component {
  componentDidMount() {
    if (!this.props.ThriveAllowed) {
      this.props.history.replace(Paths.HomeRoot);
      return;
    }
    window.location.href = this.props.IsHOL
      ? Urls.ThriveInfoExternalHOL
      : Urls.ThriveInfoExternalMOL;
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  const policy =
    state && state.policyReducer && state.policyReducer.selectedPolicy;

  return {
    ThriveAllowed:
      policy &&
      !(policy.IsSaga || policy.IsInternational || policy.IsLargeCorporate),
    IsHOL:
      state && state.layoutReducer && state.layoutReducer.layout === Layouts.HOL
  };
};

export default withRouter(connect(mapStateToProps)(ThriveInfoPage));
